/** Uzbek label and badge colours for each repair status (history list + repair page). */
export const REPAIR_STATUS_BADGES: Record<string, { label: string; className: string }> = {
  accepted: { label: 'Qabul qilingan', className: 'bg-yellow-100 text-yellow-800' },
  diagnosed: { label: 'Sozlanmoqda', className: 'bg-blue-100 text-blue-800' },
  fixed: { label: 'Tayyor', className: 'bg-green-100 text-green-800' },
  picked: { label: 'Olib ketilgan', className: 'bg-green-100 text-green-800' },
  completed: { label: 'Yakunlangan', className: 'bg-gray-100 text-gray-800' },
  cancelled: { label: 'Bekor qilingan', className: 'bg-red-100 text-red-800' },
};

export const getRepairStatusBadge = (status: string) =>
  REPAIR_STATUS_BADGES[status] ?? { label: "Noma'lum", className: 'bg-gray-100 text-gray-800' };
